const ChallengeFailed = () => (
  <svg
    focusable={false}
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={164}
    height={164}
    viewBox='0 0 164 164'
  >
    <defs>
      <path
        id='a'
        d='M0 82.048c0 45.237 36.49 81.909 81.727 81.909s82.091-36.672 82.091-81.91C163.818 36.81 126.964.14 81.727.14 36.49.139 0 36.81 0 82.048'
      />
    </defs>
    <g fill='none' fillRule='evenodd'>
      <path
        fill='#FFF'
        d='M163.818 82.048c0 45.237-36.854 81.909-82.091 81.909C36.49 163.957 0 127.285 0 82.047 0 36.812 36.49.14 81.727.14s82.091 36.672 82.091 81.909'
      />
      <mask id='b' fill='#fff'>
        <use xlinkHref='#a' />
      </mask>
      <path
        fill='#FFE2E2'
        d='M52.262 15.14h112.697l-.23 131.714H-.592'
        mask='url(#b)'
      />
      <path fill='#FFF' d='M-.91 15.14h165.869v114.52H-.591' mask='url(#b)' />
      <path
        stroke='#424547'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M184.775 146.853H-.591M164.959 15.127H-.911'
        mask='url(#b)'
      />
      <path
        fill='#7C53A5'
        d='M109.16 34.78s-6.614-7.97-7.234-19.495a1.812 1.812 0 0 0-1.8-1.725l-18.269-.05-18.27.05a1.812 1.812 0 0 0-1.799 1.725c-.62 11.525-7.234 19.494-7.234 19.494h54.606z'
        mask='url(#b)'
      />
      <path
        fill='#7C53A5'
        d='M109.16 34.78s-6.614-7.97-7.234-19.495a1.812 1.812 0 0 0-1.8-1.725l-18.269-.05.104 21.27h27.2z'
        mask='url(#b)'
      />
      <path
        stroke='#424547'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M109.16 34.78s-6.614-7.97-7.234-19.495a1.812 1.812 0 0 0-1.8-1.725l-18.269-.05-18.27.05a1.812 1.812 0 0 0-1.799 1.725c-.62 11.525-7.234 19.494-7.234 19.494h54.606z'
        mask='url(#b)'
      />
      <path
        fill='#7C53A5'
        d='M54.554 129.398s6.614 6.317 7.234 17.686c.053.962.858 1.711 1.821 1.713l18.248-.132 18.248.132a1.823 1.823 0 0 0 1.821-1.713c.62-11.37 7.234-17.686 7.234-17.686H54.554z'
        mask='url(#b)'
      />
      <path
        fill='#7C53A5'
        d='M54.554 129.398s6.614 6.317 7.234 17.686c.053.962.858 1.711 1.821 1.713l18.248-.132-.103-19.267h-27.2z'
        mask='url(#b)'
      />
      <path
        stroke='#424547'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M54.554 129.398s6.614 6.317 7.234 17.686c.053.962.858 1.711 1.821 1.713l18.248-.132 18.248.132a1.823 1.823 0 0 0 1.821-1.713c.62-11.37 7.234-17.686 7.234-17.686H54.554z'
        mask='url(#b)'
      />
      <path
        fill='#FFF'
        d='M136.515 82.048c0 30.158-24.448 54.606-54.606 54.606s-54.606-24.448-54.606-54.606c0-30.159 24.448-54.606 54.606-54.606s54.606 24.447 54.606 54.606'
        mask='url(#b)'
      />
      <path
        fill='#F4F4F7'
        d='M81.909 136.654c30.158 0 54.606-24.448 54.606-54.606 0-30.159-24.448-54.606-54.606-54.606v109.212z'
        mask='url(#b)'
      />
      <path
        stroke='#424547'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M136.515 82.048c0 30.158-24.448 54.606-54.606 54.606s-54.606-24.448-54.606-54.606c0-30.159 24.448-54.606 54.606-54.606s54.606 24.447 54.606 54.606z'
        mask='url(#b)'
      />
      <path
        fill='#FFE2E2'
        d='M129.234 82.048c0 26.137-21.188 47.325-47.325 47.325-26.137 0-47.325-21.188-47.325-47.325 0-26.137 21.188-47.326 47.325-47.326 26.137 0 47.325 21.189 47.325 47.326'
        mask='url(#b)'
      />
      <path
        fill='#f9e8eb'
        d='M81.909 34.722c26.137 0 47.325 21.189 47.325 47.326s-21.188 47.325-47.325 47.325'
        mask='url(#b)'
      />
      <path
        stroke='#C12335'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={8}
        d='M81.909 45.644c20.105 0 36.404 16.298 36.404 36.404 0 20.105-16.299 36.404-36.404 36.404-20.105 0-36.404-16.299-36.404-36.404 0-10.051 4.073-19.15 10.658-25.738'
        mask='url(#b)'
      />
      <path
        stroke='#424547'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M129.234 82.048c0 26.137-21.188 47.325-47.325 47.325-26.137 0-47.325-21.188-47.325-47.325 0-26.137 21.188-47.326 47.325-47.326 26.137 0 47.325 21.189 47.325 47.326z'
        mask='url(#b)'
      />
      <path
        fill='#F4F4F7'
        d='M136.513 87.71V76.768h.217c1.005 0 2.366.815 2.366 1.82v7.281c0 1.005-1.578 1.843-2.583 1.843'
        mask='url(#b)'
      />
      <path
        stroke='#424547'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M136.513 87.71l.763-.022a1.82 1.82 0 0 0 1.82-1.82v-7.28a1.82 1.82 0 0 0-1.82-1.82h-.763V87.71z'
        mask='url(#b)'
      />
      <path
        stroke='#E3E6E8'
        strokeWidth={2}
        d='M163.87 82.091c0 45.237-36.854 81.909-82.091 81.909C36.542 164 .052 127.328.052 82.091.052 36.854 36.542.182 81.779.182s82.09 36.672 82.09 81.909z'
        mask='url(#b)'
      />
    </g>
  </svg>
);
export default ChallengeFailed;
